import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
} from "@mui/material";

const AddExplanation = () => {
  const API_URL = process.env.REACT_APP_API_URL + "/explanations";

  const [formData, setFormData] = useState({
    verseId: "",
    reference: "",
    explanation: "",
    model: "",
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.verseId || !formData.reference || !formData.explanation) {
      setError("Required fields missing");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/v1/explanations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (res.ok) {
        setSuccess(result.message || "Saved");
        setFormData({
          verseId: "",
          reference: "",
          explanation: "",
          model: "",
        });
      } else {
        setError(result.error || "Error");
      }
    } catch (err) {
      setError("Server error");
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Add Explanation</Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>

          <Grid item xs={12} md={6}>
            <TextField
              label="Verse ID (ex: GEN.1.1)"
              name="verseId"
              value={formData.verseId}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Reference (ex: Genesis 1:1)"
              name="reference"
              value={formData.reference}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Explanation"
              name="explanation"
              value={formData.explanation}
              onChange={handleChange}
              multiline
              rows={5}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Model (optional)"
              name="model"
              value={formData.model}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <Button type="submit" variant="contained">
              Save Explanation
            </Button>
          </Grid>

        </Grid>
      </form>

      <Snackbar open={!!error} message={error} onClose={() => setError(null)} />
      <Snackbar open={!!success} message={success} onClose={() => setSuccess(null)} />
    </Box>
  );
};

export default AddExplanation;